import React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

import { FormObject } from '../../../../../@types';
import { ServiceObject } from '../../../../../@types/service.type';
import { FormInterceptor } from '../../ServiceActionBarFragment/FormInterceptor';

interface InteractionFormCardProps {
  form: FormObject;
  service: ServiceObject;
  onChange: (updatedForm: FormObject) => void;
  forms: FormObject[];
}

export const InteractionFormCard: React.FC<InteractionFormCardProps> = ({
  form,
  service,
  onChange,
  forms,
}) => (
  <Box sx={{ mb: 1.5, p: 1.5, border: '1px solid', borderColor: 'v4.border', borderRadius: 1 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
      <Typography sx={{ fontSize: '13px', fontWeight: 600 }}>{form.title}</Typography>
      {form.isMandatory && (
        <Chip label="Mandatory" size="small" sx={{ height: 18, fontSize: '9px', bgcolor: 'warning.main', color: 'common.white' }} />
      )}
    </Box>
    <FormInterceptor
      service={service}
      value={form}
      onChange={onChange}
      onDamagedPartSelect={() => {}}
      onAddForm={() => {}}
      forms={forms}
    />
  </Box>
);
